import { useQuery } from '@tanstack/react-query';
import React, { useContext, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { AuthContext } from '../contex/AuthProvider';
import UseAdmin from '../hooks/UseAdmin';
import Loading from '../page/Home/Share/Loading/Loading';
import NavBar from '../page/Home/Share/NavBar/NavBar';

const DashboardLayout = () => {
    const { user, userType } = useContext(AuthContext);
    // const [user_type, setUserType] = useState(null);
    // const { data: buyer = [], isLoading } = useQuery(
    //     {
    //         queryKey: ['buyer'],
    //         queryFn: async () => {
    //             const res = await fetch(`https://assignment-12-server-beige.vercel.app/usersType/${user.email}`);
    //             const data = await res.json();
    //             return data;
    //         }
    //     }
    // )

    // if (isLoading) {
    //     return <Loading></Loading>
    // }

    // setUserType(buyer.userType)

    const [isAdmin] = UseAdmin(user?.email)
    return (
        <div className=''>
            <NavBar></NavBar>
            <div className="drawer drawer-mobile">
                <input id="dashboard-drawer" type="checkbox" className="drawer-toggle" />
                <div className="drawer-content ">
                    <Outlet></Outlet>

                </div>
                <div className="drawer-side">
                    <label htmlFor="dashboard-drawer" className="drawer-overlay"></label>
                    <ul className="menu p-4 w-80 bg-base-100 text-base-content">

                        {userType === 'seller' && isAdmin === false &&
                            <><li><Link to='/dashboard/myproducts'>My products</Link></li>
                                <li><Link to='/dashboard/addbooks'>Add Books</Link></li></>
                        }
                        {userType === 'buyer' && isAdmin === false &&
                            <li><Link to='/dashboard/myorder'>My order</Link></li>

                        }
                        {
                            isAdmin && <>
                                <li><Link to='/dashboard/allseller'>All seller</Link></li>
                                <li><Link to='/dashboard/allbuyer'>All Buyer</Link></li>
                                <li><Link to='/dashboard/alluser'>All user</Link></li>
                            </>
                        }

                    </ul>

                </div>
            </div>
        </div>
    );
};

export default DashboardLayout;